import { Colors } from 'styles';

export const FOCUS_MODE_GRADIENT = [
  `linear-gradient(180deg, #ffffff33 0%, #ffffff00 34%, ${Colors.shadow}80 100%)`,
  `linear-gradient(90deg, ${Colors.darkBackground}33 0%, ${Colors.shadow}55 58%, ${Colors.shadow}22 100%)`,
  `linear-gradient(170deg, ${Colors.gradientStart} 0%, ${Colors.gradientEnd} 100%)`,
].join(', ');

export const FOCUS_MODE_BOX_SHADOW = `inset 0 1px 2px #ffffff66, inset 0 -2px 4px ${Colors.shadow}99`;
